import { render, staticRenderFns } from "./AdminDobNameChange.vue?vue&type=template&id=8c925686"
import script from "./AdminDobNameChange.vue?vue&type=script&lang=ts"
export * from "./AdminDobNameChange.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports